export default "__VITE_ASSET__RCXFPG0g__"